import { Check } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";
import { cn } from "@/lib/utils";
import {
  DOCUMENT_FONTS,
  documentFontClass,
  type DocumentFont,
} from "@/lib/document-fonts";
import { SettingsSection } from "@/components/settings/SettingsSection";

export function FontSelector() {
  const { documentFont, setDocumentFont } = useTheme();

  return (
    <SettingsSection
      title="Document font"
      description="Writing surface and reading view only — the rest of the app is unchanged."
    >
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {DOCUMENT_FONTS.map((font) => {
          const active = documentFont === font.id;
          return (
            <button
              key={font.id}
              type="button"
              /* The font's own class goes on the card, so the specimen below is
               * set in the face it names rather than a generic stand-in. */
              className={cn(
                documentFontClass(font.id),
                "relative flex flex-col items-start rounded-xl border border-border p-3.5 text-left transition-colors hover:bg-muted/50",
                active && "border-primary bg-muted/30",
              )}
              aria-pressed={active}
              onClick={() => setDocumentFont(font.id as DocumentFont)}
            >
              <div className="space-y-0.5 pr-7">
                <span className="doc-font-sample text-sm font-medium">
                  {font.name}
                </span>
                <p className="text-xs text-muted-foreground">{font.description}</p>
              </div>
              <p className="doc-font-sample mt-2 text-sm text-foreground/80">
                The quick brown fox jumps over the lazy dog.
              </p>
              {active && (
                <span className="absolute right-3 top-3 flex h-5 w-5 items-center justify-center rounded-full bg-primary text-primary-foreground">
                  <Check className="h-3 w-3" />
                </span>
              )}
            </button>
          );
        })}
      </div>
    </SettingsSection>
  );
}
